import { VEC_ICON_NAME } from "../../../components/icons/constants"
import { FORM_SECTION_ROUTES } from "../../formssection/constants";

export const INSIGHT_ITEMS = {
    BILL_DUE: 'BillDue',
    FORM_SUBMIT: 'FormSubmit',
    RECIPIENT_DETAILS: 'RecipientDetails',
}

export const URGENT_ITEMS = {
    IRS_REJECTED: 'IRSRjectedCount',
    REVIEW_REJECTED: 'ReviewRejectedCount',
    TIN_FAILED: 'TinFailedCount',
}

export const getUrgentIcon = (key) => {
    switch(key) {
        case URGENT_ITEMS.IRS_REJECTED:
            return VEC_ICON_NAME.FORMS_MINI_VECTOR;
        case URGENT_ITEMS.REVIEW_REJECTED:
            return VEC_ICON_NAME.FORMS_MINI_VECTOR;
        case URGENT_ITEMS.TIN_FAILED:
            return VEC_ICON_NAME.TIN_VERIFICATION_VECTOR_MINI;
    }
}

export const getUrgentLink = (key) => {
    switch(key) {
        case URGENT_ITEMS.IRS_REJECTED:
            return `${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.IRSSTATEREJECTED}`;
        case URGENT_ITEMS.REVIEW_REJECTED:
            return `${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.REVIEW_REJECTED_FORMS}`;
        case URGENT_ITEMS.TIN_FAILED:
            return `recipient?TINStatus=Rejected`;
    }
}

export const getUrgentActionLabel = (key, data) => {
    switch(key) {
        case URGENT_ITEMS.IRS_REJECTED:
            return `${data.count} forms got rejected by IRS!`
        case URGENT_ITEMS.REVIEW_REJECTED:
            return `${data.count} forms got rejected by Reviewer!`
        case URGENT_ITEMS.TIN_FAILED:
            return `${data.count} TIN verifications failed!`
    }
}


export const getInsightIcon = (key) => {
    switch(key) {
        case INSIGHT_ITEMS.BILL_DUE:
            return VEC_ICON_NAME.BILL_DUE_ICON;
        case INSIGHT_ITEMS.FORM_SUBMIT:
            return VEC_ICON_NAME.SUBMIT_FORM_ICON;
        case INSIGHT_ITEMS.RECIPIENT_DETAILS:
            return VEC_ICON_NAME.RECIPIENT_DETAILS_ICON;
    }
}

export const getInsightsMessage = (key, data) => {
    switch(key) {
        case INSIGHT_ITEMS.BILL_DUE:
            return `${data.count} requests pending! Pay Bill dues of $${data.amount}`
        case INSIGHT_ITEMS.FORM_SUBMIT:
            return `Submit ${data.count} completed forms! `
        case INSIGHT_ITEMS.RECIPIENT_DETAILS:
            return `Complete ${data.count} Recipient details with missing informations! `
    }
}